<template>
  <div>
    <template v-if="COOPERATION_NAME">
      <div class="page-top">
        <div class="top-div">
          <div
            class="left call"
            v-if="
              COOPERATION_NAME !== 'forun_zhiyun' &&
              COOPERATION_NAME !== 'zaozhuang_zhiyun' &&
              COOPERATION_NAME !== 'maotong_zhiyun' &&
              COOPERATION_NAME !== 'canggang_zhiyun'
            "
          >
            客服热线：400-088-5566
          </div>
          <div class="right">
            <div class="right info">
              <a href="javascript:;" @click="$router.push({ name: 'myFortune' })" class="mr-10">
                您好：{{ memberName.length > 16 ? memberName.substring(0, 16) + '...' : memberName }}</a
              >
              <a href="javascript:;" id="message" @click="gotoMsgCenter('18', '0')" class="">
                消息（<span id="allmsgsize">{{ tipsCountNum }}</span
                >）</a
              >
              <a
                href="/toClientDownload.html"
                target="_black"
                class="mr-10"
                v-if="
                  COOPERATION_NAME !== 'zaozhuang_zhiyun' &&
                  COOPERATION_NAME != XINJIANG_SULE &&
                  COOPERATION_NAME != ZHONGMIAN_ZHIYUN
                "
                >手机智运</a
              >
              <a href="javascript:;" @click="loginOut" class="">[退出]</a>
            </div>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-top">
        <div class="top-div">
          <div class="left call">客服热线：400-088-5566</div>
          <div class="right" v-if="channel == 'yinlun' || channel == 'zhongqi'">
            <div class="right info">
              <a href="javascript:;" @click="$router.push({ name: 'myFortune' })" class="mr-10">
                您好：{{ memberName.length > 16 ? memberName.substring(0, 16) + '...' : memberName }}</a
              >
              <a href="javascript:;" id="message" @click="gotoMsgCenter('18', '0')" class="">
                消息（<span id="allmsgsize">{{ tipsCountNum }}</span
                >）</a
              >
              <a href="javascript:;" @click="loginOut" class="">[退出]</a>
            </div>
            <div class="clear"></div>
          </div>
          <div class="right" v-else>
            <ul class="left links">
              <li class="li"><a href="https://zczy.zhiye.com/home/" target="_blank">招贤纳士</a></li>
              <li class="li"></li>
              <li class="li"><a href="https://shipnew.zczy56.com">进入船运版</a></li>
          
                
              <li class="li" >
                <a class="left link" href="#" @click="handleLink">
                  <el-badge value="新" class="badge-item">
                    <span class="">进入多式联运版</span>
                  </el-badge>
                </a>
              </li>
            
              <li class="li">
                <a href="https://owner-jms.zczy56.com/modules/mms/system/login.html" id="jmsItemLink">进入加盟商版</a>
              </li>
              <li class="li">
                <a href="http://extra-web.zczy56.com/modules/mms/system/login.html" id="extraItemLink"
                  >进入加盟运力版</a
                >
              </li>
            </ul>
            <div class="right info">
              <a href="javascript:;" @click="$router.push({ name: 'myFortune' })" class="mr-10">
                您好：{{ memberName.length > 16 ? memberName.substring(0, 16) + '...' : memberName }}</a
              >
              <a href="javascript:;" id="message" @click="gotoMsgCenter('18', '0')" class="">
                消息（<span id="allmsgsize">{{ tipsCountNum }}</span
                >）</a
              >
              <a href="/toClientDownload.html" target="_black" class="mr-10">手机智运</a>
              <a href="javascript:;" @click="loginOut" class="">[退出]</a>
              <a v-if="showGotoOld" :href="oldServicePlace" class="goto-old-service">原货主平台</a>
            </div>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </template>

    <template v-if="COOPERATION_NAME">
      <!-- <component v-bind:is="platform-header"></component> -->
      <platformHeader></platformHeader>
    </template>
    <template v-else>
      <div class="page-nav" v-if="channel == 'yinlun'">
        <div class="nav-div">
          <a href="javascript:;" class="left logo">
            <img src="@/assets/images/logo_yinlun.png" style="height: 53px; margin-top: 7px" />
          </a>
          <div class="right nav-cont">
            <a
              href="javascript:;"
              class="link link-member"
              @click="$router.push({ name: 'myFortune' })"
              style="padding: 0"
            >
              <img :src="headUrl ? headUrl : '/images/portrait.png'" class="avatar-img" />
              个人中心
            </a>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="page-nav" v-else-if="channel == 'zhongqi'">
        <div class="nav-div">
          <a href="javascript:;" class="left logo">
            <img src="@/assets/images/logo_zhongqi.png" style="margin-top: 17px" />
          </a>
          <div class="right nav-cont">
            <a
              href="javascript:;"
              class="link link-member"
              @click="$router.push({ name: 'myFortune' })"
              style="padding: 0"
            >
              <img :src="headUrl ? headUrl : '/images/portrait.png'" class="avatar-img" />
              个人中心
            </a>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="page-nav" v-else>
        <div class="nav-div">
          <a href="/" class="left logo">
            <img src="/images/logo2.png" />
          </a>
          <div class="right nav-cont">
            <a class="link" href="/">首页</a>
            <a class="link" href="/sourceOfGoods.html">货源信息</a>
            <a class="link" href="/sourceOfVehicleSource.html">车源广场</a>
            <a class="link" href="/toNewsList.html">新闻公告</a>
            
            <!-- 添加产品试用下拉菜单 -->
            <div class="link product-trial-dropdown">
              <a class="link" href="javascript:;">产品试用</a>
              <div class="dropdown-menu">
                <a href="javascript:;" @click="gotoGongYingLian('cms')" class="dropdown-item">CMS商贸管理系统</a>
                <a href="javascript:;" @click="gotoGongYingLian('tms')" class="dropdown-item">TMS运输管理系统</a>
                <a href="javascript:;" @click="gotoGongYingLian('zwms')" class="dropdown-item">WMS仓储管理系统</a>
                <a href="javascript:;" @click="gotoGongYingLian('yms')" class="dropdown-item">YMS园区管理系统</a>
                <a href="javascript:;" @click="gotoGongYingLian('fms/digitalCommunication')" class="dropdown-item">数信通·运费通</a>
              </div>
            </div>
            
            <a href="javascript:;" class="link link-member" @click="$router.push({ name: 'myFortune' })">
              <img :src="headUrl ? headUrl : '/images/portrait.png'" class="avatar-img" />
            </a>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </template>

    <div class="page-subnav">
      <div class="subnav-div">
        <div class="left links subnav-div-links">
          <template v-for="(item, index) in links">
            <el-badge
              v-if="tipsCountNum > 0 && item.visible && item.pathName == 'messageList'"
              :key="index"
              :value="tipsCountNum"
              :max="999"
            >
              <a :class="{ active: item.pathName === $route.name }" class="link" @click="clickLink(item, index)">
                {{ item.name }}
              </a>
            </el-badge>
            <a
              v-else-if="item.visible"
              :key="index"
              :class="{ active: item.pathName === $route.name }"
              class="link"
              @click="clickLink(item, index)"
            >
              {{ item.name }}
            </a>
          </template>
          <a v-if="bidSwitchFlag == '1'" :class="{ active: pageName == 'index' }" class="link" href="/bid/index.html"
            >招标平台</a
          >
          <div class="left" style="position: relative">
            <a :class="{ active: pageName == 'report' }" class="link" href="/bid/report.html"
              >统计报表<i class="icon-new"></i
            ></a>
            <div class="new-tip-step" v-if="stepShow" style="width: 322px; top: 50px">
              <div class="tip-arrow"></div>
              <div class="tip-icon">
                <img src="@/assets/images/custom_new.gif" style="position: absolute; top: -6px; left: -40px" />
              </div>
              <div class="tip-title">统计报表搬家啦！功能更强大~</div>
              <div class="tip-close" @click="stepHandle"></div>
              <div class="tip-info">
                <div class="tip-row">1、报表统计支持自定义筛选，更精简、更加个性化~</div>
                <div class="tip-row">2、更多维度的数据统计，并且支持定制表！</div>
              </div>
              <div class="tip-oper">
                <a href="javascript:;" class="btn-jump" @click="stepHandle">跳过</a>
                <a href="javascript:;" class="btn-see" @click="stepHandle(true)">去看看</a>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div style="margin: 18px 10px 0 0" v-if="isSpecificUrlPrefix()">
            <el-button-select v-model="currentVersion" :options="options" />
          </div>
          <div style="margin-top: 21px">
            <img v-if="isInCollectionList" src="@/assets/images/menu/collect.png" @click="doCollectionMenu(0)" />
            <img v-else src="@/assets/images/menu/unCollect.png" @click="doCollectionMenu(1)" />
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { loginService } from '@/services/login';
import { consignorService } from '@/services/consignor';
import { mapState, mapGetters, mapMutations } from 'vuex';
import vipKefuJs from '@/assets/js/vipKefu';
import platformHeader from '@/views/platform/components/platformHeader.vue';
import roleApi from '@/services/info/role';
import elButtonSelect from '@/components/el-button-select';
import { getTempToken } from '@/services/ownerFreightloan/drawDeposit';
export default {
  name: 'MemberHeader',
  components: {
    platformHeader: platformHeader,
    elButtonSelect: elButtonSelect
  },
  data() {
    let vm = this;
    const userIdCookie = document.cookie.split('; ').find((row) => row.startsWith('userIds='));
    const userIds = userIdCookie ? JSON.parse(userIdCookie.split('=')[1]) : [];

    // 假设当前用户的 userId 存储在 localStorage 中
    const currentUserId = localStorage.getItem('userId');

    // 检查 userIds 数组中是否包含当前用户的 userId
    const dlvisible = !userIds.includes(currentUserId);
    return {
      userName: '',
      memberName: '',
      headUrl: '',
      active: '0',
      links: [
        {
          name: '我的智运',
          pathName: 'myFortune',
          documentTitle: '我的智运-个人中心',
          visible: true
        },
        {
          name: '消息中心',
          pathName: 'messageList',
          documentTitle: '消息中心',
          visible: true
        },
        {
          name: '智运账本',
          pathName: 'myPay',
          documentTitle: '我的智运-智运账本',
          visible: vm.$utils.checkPermission(['zyb:zybaccountbook'])
        },
        {
          name: '智运账本-部门专户',
          pathName: 'myPayDept',
          documentTitle: '我的智运-智运账本-部门专户',
          visible: vm.$utils.checkPermission(['consig:departmentalAccountManagement'])
        },
        {
          name: '交易通钱包',
          pathName: 'jiaoyitong',
          documentTitle: '我的智运-交易通钱包',
          visible: vm.$utils.checkPermission(['consig:jytqb'])
        },
        {
          name: '区块链浏览器',
          pathName: 'BlockChain',
          documentTitle: '我的智运-区块链浏览器',
          // visible: vm.$utils.checkPermission(['zyb:zybaccountbook'])
          visible: vm.$utils.checkPermission(['consig:creditCertificate:query'])
        },
        {
          name: '合同管理系统',
          pathName: 'Contract',
          documentTitle: '我的智运-合同管理系统',
          visible: true
        }
      ],
      // 是否有权限访问招投标 bidSwitchFlag  0否 1是
      bidSwitchFlag: '',
      stepShow: false,
      pageName: '',
      showGotoOld: false,
      // 企业定制头部
      channel: '',
      oldServicePlace: 'https://www.zczy56.com/modules/mms/system/login.html',
      COOPERATION_NAME: '',
      XINJIANG_SULE: '',
      ZHONGMIAN_ZHIYUN: '',
      dlvisible: dlvisible,
      versionObj: {
        version: 1
      },
      options: [
        {
          label: 1,
          value: '旧版'
        },
        {
          label: 2,
          value: '新版'
        }
      ]
    };
  },
  computed: {
    ...mapGetters('user', ['tipsCount', 'warningFlag', 'dictConfig','version']),
    ...mapGetters('log', ['currentMenus', 'activeSubMenu', 'collectionList']),
    currentVersion: {
      get() {
        return localStorage.getItem('version') || this.version
      },
      set(val) {
        localStorage.setItem('version', val);
        this.SET_VERSION(val)
      }
    },
    tipsCountNum() {
      return this.tipsCount;
    },
    isInCollectionList() {
      return this.collectionList.find((it) => it.url === this.$route.name);
    }
  },
  created() {
    try {
      this.COOPERATION_NAME = COOPERATION_NAME;
      this.XINJIANG_SULE = XINJIANG_SULE;
      this.ZHONGMIAN_ZHIYUN = ZHONGMIAN_ZHIYUN;
    } catch (error) {
      
    }
    // alert(COOPERATION_NAME)
  },
  methods: {
    ...mapMutations('log', ['SET_MENULIST']),
    ...mapMutations('user', ['SET_VERSION']),
  
    isSpecificUrlPrefix() {
      const currentUrl = window.location.href;
      const specificPrefix = 'http://172.20.20.23:8879/';
      const ip192Prefix = 'http://192.168';
      return currentUrl.startsWith(specificPrefix) || currentUrl.startsWith(ip192Prefix);
    },
    addUserIdToCookie(userId) {
      // 读取 cookie 中的现有 userId 数组
      const userIdCookie = document.cookie.split('; ').find((row) => row.startsWith('userIds='));
      let userIds = userIdCookie ? JSON.parse(userIdCookie.split('=')[1]) : [];

      // 添加新的 userId 到数组中
      if (!userIds.includes(userId)) {
        userIds.push(userId);
      }

      // 将更新后的数组序列化为 JSON 字符串并存储回 cookie
      document.cookie = `userIds=${JSON.stringify(userIds)}; path=/`;
    },
    removeElementById(elementId) {
      var element = document.getElementById(elementId);
      if (element) {
        var parent = element.parentNode;
        if (parent) {
          parent.removeChild(element);
        }
      }
    },
    gotoTms() {},
    loginOut() {
      // 处理银轮定制
      let obj = { name: 'Login' };
      let isOwnerCS = localStorage.getItem('isOwnerCS');
      this.removeElementById('myIframe');
      if (this.channel && this.channel != 'null' && this.channel != 'undefined') {
        obj.query = {
          channel: this.channel
        };
      } else {
        this.channel = '';
        localStorage.setItem('channel', '');
      }
      // this.$router.push({ name: 'Login' })
      loginService
        .logout({ sessionId: localStorage.getItem('tokenId') })
        .then((res) => {
          if (res && res.code === '200') {
          }
          vipKefuJs.removeVipKefuData();
          this.$store.dispatch('resetState');
          localStorage.clear();
          localStorage.setItem('channel', this.channel);
          localStorage.setItem('isOwnerCS', isOwnerCS);
          this.$router.push(obj);
          this.SET_MENULIST(null);
        })
        .catch((err) => {
          localStorage.clear();
          localStorage.setItem('channel', this.channel);
          localStorage.setItem('isOwnerCS', isOwnerCS);
          this.$router.push(obj);
          this.SET_MENULIST(null);
        });
    },
    gotoGongYingLian(type) {
       getTempToken({ tenantCode: 'ZCZY', systemFlag: 10 }).then((res2) => { 
          let userName = localStorage.getItem('memberName');
          if (res2.code == '200') {
            let url = `http://sit.supply-portal.zczy.com/emptyPage?jumpParams=/${type}&isWh=true&userName=${userName}`;
            if (location.href.indexOf('hz.zczy56.com') > -1 || localStorage.getItem('officially') == '1') {
              url = `https://scm.zczy56.com/emptyPage?jumpParams=/${type}&isWh=true&userName=${userName}`;
            }
            
            window.open(url + '&token=' + res2.data.token, '_blank');
          }
        });
    },
    clickLink(item, index) {
      if (item.pathName === 'myPay') {
        window.location.href = '/pay/index.html';
        return '';
      }
      if (item.pathName === 'myPayDept') {
        window.location.href = '/pay/index.html#/departmentAccountIndex';
        return '';
      }

      if (item.pathName === 'jiaoyitong') {
        window.location.href = '/pay/index.html#/jiaoyitongIndex';
        return '';
      }

      if (item.pathName === 'Contract') {
        getTempToken({ tenantCode: 'ZCZY', systemFlag: 34 }).then((res2) => {
          if (res2.code == '200') {
            let url = `http://sit.scm.zczy.com/#/emptyPage?jumpParams=personalInfo`;
            if (location.href.indexOf('hz.zczy56.com') > -1 || localStorage.getItem('officially') == '1') {
              url = `https://scm.zczy56.com/ams/customer/#/emptyPage?jumpParams=personalInfo`;
            }
            window.open(url + '&token=' + res2.data.token, '_blank');
          }
        });
        return '';
      }
      this.$router.push({
        name: item.pathName
      });
      this.$nextTick(() => {
        this.active = index + '';
      });
      document.title = item.documentTitle;
    },
    gotoMsgCenter(tab, messageType) {
      this.$router.push({
        path: '/publicPage/messageList',
        query: {
          tab: tab,
          messageType: messageType
        }
      });
    },
    initCustomStep() {
      this.stepShow = false;
      consignorService.consignorOrderReportTipsFlag({}).then((res) => {
        if (res.resultCode == '0000') {
          if (res.data.showFlagStep1 == '1') {
            this.stepShow = true;
          }
        }
      });
    },
    stepHandle(turnBool) {
      consignorService.changeConsignorOrderReportTipsFlag({ showFlagStep1: '0' }).then((res) => {
        console.log(res);
        if (turnBool) {
          this.location.href = '/statics/bid/report.html';
        }
      });
      this.stepShow = false;
    },
    doCollectionMenu(type) {
      //操作类型 0-取消 1-收藏
      roleApi
        .collectMenu({
          operateType: type,
          menuId: this.activeSubMenu
        })
        .then(() => {
          this.$store.dispatch('log/getCollectionList');
        });
    },
    closeFirstTip() {
      this.dlvisible = false;
      this.addUserIdToCookie(localStorage.getItem('userId'));
    },
    async handleLink() {
      // 获取临时token
      const params = {
        tenantCode: 'ZCZY',
        systemFlag: 2,
        mTmsFlag: 1
      };
      getTempToken(params).then((res2) => {
        if (res2.code == '200') {
          let url = `http://172.20.20.23:9190/#/dashboard`;
          if (location.href.indexOf('hz.zczy56.com') > -1 || localStorage.getItem('officially') == '1') {
            url = `https://scm.zczy56.com/mtms/consignor/#/dashboard`;
          }
          if (res2.data.token) {
            window.open(url + '?token=' + res2.data.token, '_blank');
          } else if (res2.data.jumpType == 1) {
            url = window.location.origin + '/consignor.html#/cooperativeConsultation';
            window.open(url, '_blank');
          } else if (res2.data.jumpEnable == 0) {
            this.$message({
              message: res2.data.resultMsg,
              type: 'warning'
            });
          }
        }
      });
    }
  },
  mounted() {
    let href = window.location.href;

    let jmsItemLink = document.getElementById('jmsItemLink');
    let extraItemLink = document.getElementById('extraItemLink');

    if (href.indexOf('pre-hz') !== -1) {
      this.oldServicePlace = 'http://pre.zczy-web.zczy.com/modules/mms/system/login.html';
      if (jmsItemLink) {
        jmsItemLink.setAttribute('href', 'http://pre.zczy-franchiser-web.zczy.com/modules/mms/system/login.html');
      }
      if (extraItemLink) {
        extraItemLink.setAttribute('href', 'http://pre.zczy-entry-web.zczy.com/modules/mms/system/login.html');
      }
    } else if (
      href.indexOf('hz.zczy') !== -1 ||
      href.indexOf('jszczy56.com') !== -1 ||
      href.indexOf('zczyah.com') !== -1 ||
      href.indexOf('zczytj.com') !== -1 ||
      href.indexOf('longkou.zczy100.com') !== -1
    ) {
      this.oldServicePlace = 'https://www.zczy56.com/modules/mms/system/login.html';
    } else {
      this.oldServicePlace = 'http://sit.zczy-web.zczy.com/modules/mms/system/login.html';
      if (jmsItemLink) {
        jmsItemLink.setAttribute('href', 'http://sit.zczy-franchiser-web.zczy.com/modules/mms/system/login.html');
      }
      if (extraItemLink) {
        extraItemLink.setAttribute('href', 'http://sit.zczy-entry-web.zczy.com/modules/mms/system/login.html');
      }
    }

    this.userName = localStorage.getItem('userName');
    this.memberName = localStorage.getItem('memberName') ||'';
    this.headUrl = localStorage.getItem('headUrl');
    this.channel = localStorage.getItem('channel');
    this.initCustomStep();
    let OLD_PC_NOT_LOGIN_SWITCH = this.dictConfig['OLD_PC_NOT_LOGIN_SWITCH'];
    this.showGotoOld =
      OLD_PC_NOT_LOGIN_SWITCH && OLD_PC_NOT_LOGIN_SWITCH.length ? OLD_PC_NOT_LOGIN_SWITCH[0][1] == 0 : false;
    consignorService.getUserInfo({}).then((res) => {
      if (res) {
        this.bidSwitchFlag = res.bidSwitchFlag;
      }
    });

    if (this.channel == 'zhongqi') {
      let liAppDom = document.querySelector('.li-app');
      if (liAppDom) {
        liAppDom.style.display = 'none';
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.right {
  display: flex;
}
.dl-tips{
  position: absolute;
  top: 0;
  left: 0;
  z-index : 999999;
  width: 100px;
  }
/deep/ .dark-popover{
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  color: #fff;
  top: 29px;
  left: 42%;
}
/deep/ .dark-popover .popper__arrow {
  top: -7px;
}
/deep/ .dark-popover .popper__arrow::after {
  border-bottom-color: rgba(0, 0, 0, 0.7) !important;
}
.badge-item {
  vertical-align:initial;
  /deep/ .el-badge__content.is-fixed {
    font-size: 12px;
    transform: translateY(-50%) translateX(100%) scale(0.9);
    z-index: 4;
  }
}
.first-login {
  /deep/ .el-badge__content.is-fixed {
    top: 1px;
  }
  span {
    position: relative;
    display: inline-block;
    margin-top: -1px;
    padding: 1px 10px;
    border: 4px solid #555555;
    background-color: #e0828e;
    transform: scale(1.5) translateX(-18px);
    z-index: 3;
  }
}
.page-top
  font-size 12px
  width 100%
  min-width 1200px
  height 28px
  line-height 28px
  background #000C17
  .top-div
    width: 1200px
    margin: auto
    height: 28px
    line-height 28px
    .call
      color: #FFFFFF
      margin-left: 16px
    .links
      overflow: hidden
      margin-right 16px
      .li
        float: left
        color: #FFF
        position relative
        a
          color: #ffb769
          display inline-block
          padding 0 10px
        a:hover
          color: #f60
        &:after
          content ""
          position absolute
          width 1px
          height 12px
          top 8px
          right 0
          background #fff
        &:last-child:after
          display none
    .info
      color: #FFF
      a
        color #fff
        display inline-block
        margin-left 10px
.page-nav
  width: 100%
  height: 64px
  line-height: 63px
  background: #FFF
  border-bottom: 1px solid #EFF0F3
  box-shadow: 0px 1px 4px 0px #E1E6EB
  .nav-div
    width: 1200px
    margin: auto
    .logo
      overflow hidden
      height 64px
    .nav-cont
      .link
        padding 0 20px
      .link-member
        padding-right 0
        .avatar-img
          float left
          margin 20px 10px 0 0
          width 24px
          height 24px
          border-radius 12px
.page-subnav
  background:#fff
  border-bottom:1px solid #E8E8E8
  min-width: 1200px
  .subnav-div
    width: 1200px
    margin: auto
    .links
      .link
        float left
        height 54px
        line-height 54px
        display inline-block
        padding: 0 16px
      .active
        color #5086FC
  .subnav-div
    cursor pointer
</style>
<style>
.common_change_tip .common_change_tip_content .li-tag {
  height: 22px;
  line-height: 22px;
  background: #ef8181;
  color: #fff;
  border-radius: 11px;
  position: unset;
  padding: 0 8px;
}
.new-tip-step {
  padding: 12px;
  background: #1890ff;
  border-radius: 5px;
  box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 999;
  line-height: 20px;
}
.new-tip-step .tip-arrow {
  position: absolute;
  top: -12px;
  left: 60px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-bottom-color: #1890ff;
}

.new-tip-step .tip-close {
  position: absolute;
  width: 24px;
  height: 24px;
  top: 0;
  right: 0;
  background: url(../assets/images/step_tip_close.png) center center no-repeat;
  cursor: pointer;
}

.new-tip-step .tip-close:hover {
  opacity: 0.8;
}

.new-tip-step .tip-title {
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  padding: 5px;
}

.new-tip-step .tip-info {
  font-size: 12px;
  color: #fff;
  padding-right: 20px;
}
.new-tip-step .tip-info .tip-row {
  padding-bottom: 5px;
}
.new-tip-step .tip-oper {
  text-align: right;
  padding-top: 5px;
}
.new-tip-step .tip-oper .btn-jump {
  display: inline-block;
  padding: 0 15px;
  color: #fff;
  font-size: 12px;
}
.new-tip-step .tip-oper .btn-jump:hover {
  color: #fff;
  opacity: 0.8;
}
.new-tip-step .tip-oper .btn-see {
  font-size: 12px;
  display: inline-block;
  padding: 0 15px;
  background: #fff;
  color: #1890ff;
  border-radius: 10px;
  line-height: 20px;
}
.new-tip-step .tip-oper .btn-see:hover {
  opacity: 0.8;
}

.page-subnav .subnav-div .links .link .icon-new {
  position: absolute;
  right: -10px;
  top: 5px;
  width: 24px;
  height: 14px;
  background: url(../assets/images/icon_new.png) 0 0 no-repeat;
}

.el-menu-item .icon-new,
.el-submenu .el-menu-item .icon-new {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 24px;
  height: 14px;
  background: url(../assets/images/icon_new.png) 0 0 no-repeat;
}
.goto-old-service {
  background: rgba(255, 255, 255, 0.16);
  border-radius: 4px;
  border: 1px solid #ffffff;
  width: 64px;
  width: 64px;
  height: 15px;
  font-size: 10px;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 14px;
  text-align: center;
}
.subnav-div-links {
  display: flex;
}
.left.links.subnav-div-links .el-badge__content.is-fixed {
  top: 9px;
  right: 18px;
}
.left.links.subnav-div-links .el-badge {
  display: block;
}
.need_recharge_warning {
  color: #fc2100;
  height: 54px;
  line-height: 54px;
  padding-right: 18px;
}
.need_recharge_warning:hover {
  color: #fc2100;
}
.need_recharge_warning img {
  width: 20px;
  vertical-align: text-top;
}
</style>
<style lang="stylus">
/* 在文件末尾添加以下样式 */
.product-trial-dropdown {
  position: relative;
  display: inline-block;
  
  .dropdown-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    min-width: 160px;
    padding: 5px 0;
    margin: 0;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    
    .dropdown-item {
      display: block;
      padding: 8px 16px;
      clear: both;
      font-weight: 400;
      color: #333;
      text-align: left;
      white-space: nowrap;
      line-height: 1.5;
      
      &:hover {
        background-color: #f5f7fa;
        color: #5086FC;
      }
    }
  }
  
  &:hover .dropdown-menu {
    display: block;
  }
}
</style>
